/**
 * Cytoscape stylesheet generated from `ontology/display-styles.json` (spec §15.6): a new ontology
 * needs one `km:displayStyle` annotation, not frontend code. Edge styles encode provenance.
 */
import type { StylesheetJsonBlock } from "cytoscape";
import displayStyles from "../../../../ontology/display-styles.json";

export type StyleOverrides = Record<string, Record<string, unknown>>;
type Stylesheet = StylesheetJsonBlock[];

export const STYLE_KEYS = Object.keys(displayStyles);

export function buildStylesheet(overrides: StyleOverrides = {}): Stylesheet {
  const rules: Array<{ selector: string; style: Record<string, unknown> }> = [
    {
      selector: "node",
      style: {
        label: "data(label)",
        "font-size": 9,
        color: "#444",
        "text-valign": "bottom",
        "text-margin-y": 3,
        "text-wrap": "ellipsis",
        "text-max-width": "120px",
        width: 26,
        height: 26,
        "background-color": "#9aa5b1",
      },
    },
    ...Object.entries(displayStyles).map(([key, style]) => ({ selector: `node[style = "${key}"]`, style: style as Record<string, unknown> })),
    { selector: "node[thumb]", style: { "background-image": "data(thumb)", "background-fit": "cover", "background-color": "#ffffff" } },
    {
      selector: ":parent",
      style: { shape: "round-rectangle", "background-opacity": 0.06, "border-width": 1, "border-color": "#999", "text-valign": "top", "text-margin-y": -4 },
    },
    { selector: "node:selected", style: { "border-width": 3, "border-color": "#d1495b" } },
    {
      selector: "edge",
      style: {
        width: 1.5,
        "curve-style": "bezier",
        "target-arrow-shape": "triangle",
        "arrow-scale": 0.8,
        label: "data(label)",
        "font-size": 7,
        color: "#666",
        "text-rotation": "autorotate",
        "line-color": "#7a8aa0",
        "target-arrow-color": "#7a8aa0",
      },
    },
    { selector: 'edge[provenance = "asserted"]', style: { "line-style": "solid" } },
    { selector: 'edge[provenance = "computed"]', style: { "line-style": "dotted" } },
    { selector: 'edge[provenance = "derived"]', style: { "line-style": "dashed", opacity: "mapData(conf, 0, 1, 0.3, 1)" } },
    // stale derived edges: the block changed after extraction (spec §18.6)
    { selector: "edge[stale = 1]", style: { "line-color": "#b58900", "target-arrow-color": "#b58900", "line-dash-pattern": [1, 4], opacity: 0.55 } },
    { selector: 'edge[provenance = "ontology"]', style: { width: 0.7, "line-color": "#bbbbbb", "target-arrow-color": "#bbbbbb" } },
    { selector: "edge:selected", style: { width: 3, "line-color": "#d1495b", "target-arrow-color": "#d1495b" } },
    ...Object.entries(overrides).map(([selector, style]) => ({ selector, style })),
  ];
  return rules as unknown as Stylesheet;
}
